import { Flex } from '@abyss/web/ui/Flex';
import React from 'react';

import { ISquareContainerProps } from './types';

export const IconContainer = ({
  size,
  ...otherProps
}: ISquareContainerProps) => (
  <Flex
    {...otherProps}
    css={{ height: size, width: size, position: 'relative' }}
  />
);
